// Hook to track tab visibility
// NOTE: This hook is intentionally simplified to prevent state loss issues
// The original implementation triggered re-renders and reconnection attempts
// that caused the app to lose user input when switching tabs
// import { useEffect, useState } from 'react'

export function useTabVisibility() {
    // Always return true to prevent any visibility-based re-renders
    // This is a temporary fix until a proper reconnection strategy is implemented
    return true
} 